
import Vue from 'vue'
import Vuex from 'vuex'
import decode from 'jwt-decode'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    token: null,
    imagem: null,
    permissoes: null,
    loading: false
  },
  actions: {
    setToken ({ commit }, obj) {
      commit('SET_TOKEN', obj)
    },
    setPermissoes ({ commit }, obj) {
      commit('SET_PERMISSOES', obj)
    },
    removeToken ({ commit }) {
      commit('REMOVE_TOKEN')
    },
    setImagem ({ commit }, obj) {
      commit('SET_IMAGEM', obj)
    },
    setLoading ({ commit }, obj) {
      commit('SET_LOADING', obj)
    }
  },
  mutations: {
    SET_TOKEN (state, obj) {
      state.token = obj.token
    },
    SET_PERMISSOES (state, obj) {
      state.permissoes = obj.permissoes
    },
    REMOVE_TOKEN (state) {
      state.token = null
      state.permissoes = null
      state.imagem = null
    },
    SET_IMAGEM (state, obj) {
      state.imagem = obj.imagem
    },
    SET_LOADING (state, obj) {
      state.loading = obj.loading
    }
  },
  getters: {
    email (state) {
      const { token } = state
      if (token != null) {
        const decoded = decode(token)
        return decoded.user.email
      }
      return ''
    },
    imagem (state) {
      const { imagem } = state
      if (imagem) {
        return `${process.env.UPLOADS_URL}/usuarios/${imagem}`
      }
      return ''
    },
    nome (state) {
      const { token } = state
      if (token != null) {
        const decoded = decode(token)
        return decoded.user.nome
      }
      return ''
    },
    sobrenome (state) {
      const { token } = state
      if (token != null) {
        const decoded = decode(token)
        return decoded.user.sobrenome
      }
      return ''
    },
    permissoes (state) {
      const { permissoes } = state
      if (permissoes != null) {
        const decoded = decode(permissoes)
        return decoded.permissoes
      }
      return ''
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js